import { takeEvery, put, call } from 'redux-saga/effects';

import { requestPost, requestGet } from '../utils/request';
import {
  PAGES, API_URLS, MODALS, FETCH_OPTIONS,
} from '../constants';
import { aLogin, aLogout } from '../reducers';
import { aLoginError, aLoginSuccess, aLogoutSuccess, aSetIsFetching, aSetIsLoading, aSetOpenModal } from '../reducers/common';

/**
 * @namespace sagas/auth
 */
/**
 * @memberof sagas/auth
 * @typedef User
 * @type {object}
 * @property {Array} permissions
 * @property {boolean} requireNewPassword
 * @property {Array} roles
 * @property {number} userId
 * @property {string} username
 */
/**
 * @memberof sagas/auth
 * @typedef login/response.data
 * @type {object}
 * @property {User} user
 * @property {string} sessionId
 */
/**
 * @memberof sagas/auth
 * @async
 * @param {object} action
 */
function* login(action) {
  let response;
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.LOGIN,
      value: true,
    }));
    yield put(aSetIsLoading({
      isLoading: true,
    }));
    response = yield call(requestPost, API_URLS.LOGIN, {
      username: action.payload.username,
      password: action.payload.password,
    }, false);
    if (response.status === -1) {
      yield put(aLoginError({
        loginError: response.error.message,
      }));
    } else {
      yield put(aLoginSuccess({
        user: response.data.user,
      }));
      action.payload.navigate(PAGES.HOME);
    }
    yield put(aSetIsLoading({
      isLoading: false,
    }));
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.LOGIN,
      value: false,
    }));
  } catch (error) {
    if (!error.modal) {
      yield put(aSetOpenModal({
        modal: MODALS.GENERAL_ERROR,
        errorMessage: MODALS.GENERAL_ERROR,
        key: FETCH_OPTIONS.LOGIN,
        value: false,
      }));
    }
  }
}

/**
 * @memberof sagas/auth
 * @async
 * @param {object} action
 * @property {object} action
 * @property {boolean} action.payload Call api or not
 */
function* logout(action) {
  try {
    if (action.payload.callAPI) {
      yield put(aSetIsFetching({
        key: FETCH_OPTIONS.LOGOUT,
        value: true,
      }));
      yield put(aSetIsLoading({
        isLoading: true,
      }));

      yield call(requestGet, API_URLS.LOGOUT, false);
    }
  } finally {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.LOGOUT,
      value: false,
    }));
    yield put(aLogoutSuccess());
    action.payload.navigate(PAGES.LOGIN);
    yield put(aSetIsLoading({
      isLoading: false,
    }));
  }
}

/**
 * @memberof sagas/auth
 * @async
 * @returns {void}
 */
export default function* authSaga() {
  yield takeEvery(aLogin, login);
  yield takeEvery(aLogout, logout);
}
